import axios, { AxiosResponse } from "axios"
import jstz from "jstz"
import { getServicePath } from "./Frontend"
import { getFrontendInstance } from "./FrontendInstance"

export interface VerifiedUserInfo {
    verifiedUserID: number
    verifiedEmail: string
    verifiedFullName: string
    verifiedTimeZone: string
    sessionNameForLogging: string
}

export async function getSessionInfo(): Promise<VerifiedUserInfo | undefined> {
    //    const sessionToken = getCookie('sessionToken')
    //    if(sessionToken === undefined)
    //        return undefined

    const path = getServicePath("authentication") + "sessionInfo"
    //console.log(path)
    const response = await axios.get(path, { withCredentials: true })

    if (response.status !== 200) return undefined

    const sessionInfo = response.data as VerifiedUserInfo

    if (sessionInfo.verifiedUserID === undefined) return undefined

    if (sessionInfo.verifiedEmail === undefined) return undefined

    if (sessionInfo.verifiedFullName === undefined) return undefined

    if (sessionInfo.verifiedTimeZone === undefined) return undefined

    if (sessionInfo.sessionNameForLogging === undefined) {
        // If the server doesn't have this information, we can try to generate something that is similar
        sessionInfo.sessionNameForLogging = sessionInfo.verifiedUserID + "/" + sessionInfo.verifiedEmail
    }

    return sessionInfo
}

export async function login(username: string, password: string): Promise<boolean> {
    //    const sessionToken = getCookie('sessionToken')
    //    if(sessionToken === undefined)
    //        return undefined

    try {
        const detectedTimeZone = jstz.determine().name()

        const response = await axios.post(
            getServicePath("authentication") + "loginBrowser",
            { username, password, detectedTimeZone },
            {
                withCredentials: true,

                validateStatus: status => true,
            },
        )

        if (response.status === 401) return false

        if (response.status === 200) return true

        // getFrontendInstance().reportError(`Server returned error ${response.status}: ` + response.data)
    } catch (e) {}
    return false
}

export async function logout(): Promise<void> {
    await axios.post(getServicePath("authentication") + "logout", { redirectUrl: window.location.href })
    window.location.reload()
}

export async function register(
    username: string,
    password: string,
    firstName: string | null,
    lastName: string | null,
): Promise<boolean> {
    try {
        const detectedTimeZone = jstz.determine().name()

        const response = await axios.post(
            getServicePath("authentication") + "register",
            { username, password, detectedTimeZone, firstName, lastName },
            {
                withCredentials: true,

                validateStatus: status => true,
            },
        )

        if (response.status === 401) return false

        if (response.status === 200) return true

        getFrontendInstance().reportError(`Server returned error ${response.status}: ` + response.data)
    } catch (e) {}
    return false
}

export async function resetPassword(username: string): Promise<boolean> {
    let response: AxiosResponse<unknown, unknown> 
    try {
        response = await axios.post(
            getServicePath("authentication") + "resetPassword",
            { username },
            {
                withCredentials: true,

                validateStatus: status => true,
            },
        )

        if (response.status === 200) return true

        getFrontendInstance().reportError(`Server returned error ${response.status}: ` + response.data)
        return false
    } catch (e) {
        getFrontendInstance().reportError("Failed to reset password: " + (e as Error).message)
    }
    return false
}
